export default __webpack_public_path__ + "static/media/loader_2_d.168c67b7.png";